"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

require("core-js/modules/es6.object.assign");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var editor_1 = require("./editor");
/**
 * CodeMirror editor factory.
 */


var CodeMirrorEditorFactory =
/**
 * Construct an IEditorFactoryService for CodeMirrorEditors.
 */
function CodeMirrorEditorFactory() {
  var _this = this;

  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, CodeMirrorEditorFactory);

  /**
   * Create a new editor for inline code.
   */
  this.newInlineEditor = function (options) {
    options.host.dataset.type = 'inline';
    return new editor_1.CodeMirrorEditor(Object.assign({}, options, {
      config: Object.assign({}, _this.inlineCodeMirrorConfig, options.config || {})
    }));
  };
  /**
   * Create a new editor for a full document.
   */


  this.newDocumentEditor = function (options) {
    options.host.dataset.type = 'document';
    return new editor_1.CodeMirrorEditor(Object.assign({}, options, {
      config: Object.assign({}, _this.documentCodeMirrorConfig, options.config || {})
    }));
  };

  this.inlineCodeMirrorConfig = Object.assign({}, editor_1.CodeMirrorEditor.defaultConfig, {
    extraKeys: {
      'Cmd-Right': 'goLineRight',
      End: 'goLineRight',
      'Cmd-Left': 'goLineLeft',
      Tab: 'indentMoreOrinsertTab',
      'Shift-Tab': 'indentLess',
      'Cmd-/': 'toggleComment',
      'Ctrl-/': 'toggleComment'
    }
  }, defaults);
  this.documentCodeMirrorConfig = Object.assign({}, editor_1.CodeMirrorEditor.defaultConfig, {
    extraKeys: {
      Tab: 'indentMoreOrinsertTab',
      'Shift-Tab': 'indentLess',
      'Cmd-/': 'toggleComment',
      'Ctrl-/': 'toggleComment',
      'Shift-Enter': function ShiftEnter() {
        /* no-op */
      }
    },
    lineNumbers: true,
    scrollPastEnd: true
  }, defaults);
};

exports.CodeMirrorEditorFactory = CodeMirrorEditorFactory;